import LogoIcon from '../../../assets/images/lockers_logo.png';

const Logo = (props: any) => {
  return <img src={LogoIcon} alt="" style={props.style} />;
};

export default Logo;
